const ExamShedule = () => {
    return (
        <div className="bg-gray-100 px-2">
            <div className="pt-12">

                <h1 className="text-xl pb-2">Examination</h1>
                <span className="flex">
                    <h2>Home &gt;</h2>
                    <h2 className="text-yellow-500">Exam Schedule</h2>
                </span>

            </div>


            <div className="">
                <h2>Add New Exam</h2>

                <div className="text-gray-700 grid grid-cols-1 md:grid-cols-2">
                    <span>
                        <label>Exam Name</label>
                        <input type="text" className="outline-none bg-gray-200" />
                    </span>
                    <span>
                        <label>Subject Type</label>
                        <div class="relative">
                            <select class="block appearance-none w-full bg-gray-200 border border-gray-300 hover:border-gray-400 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                                <option value="">Select an option</option>
                                <option value="option1">English</option>
                                <option value="option2">Mathematics</option>
                                <option value="option3">Civic</option>
                            </select>
                            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                    <path d="M10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
                                </svg>
                            </div>
                        </div>
                    </span>

                    <span>
                        <label htmlFor="text">Select Class</label>
                        <div class="relative">
                            <select class="block appearance-none w-full bg-gray-200 border border-gray-300 hover:border-gray-400 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                                <option value="">Select an option</option>
                                <option value="option1">1</option>
                                <option value="option2">2</option>
                                <option value="option3">3</option>
                            </select>
                            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                    <path d="M10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
                                </svg>
                            </div>
                        </div>
                    </span>
                    <span>
                        <label htmlFor="dropdown">Select Section</label>
                        <div class="relative">
                            <select class="block appearance-none w-full bg-gray-200 border border-gray-300 hover:border-gray-400 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                                <option value="">Select an option</option>
                                <option value="option1">1</option>
                                <option value="option2">2</option>
                                <option value="option3">3</option>
                            </select>
                            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                    <path d="M10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
                                </svg>
                            </div>
                        </div>
                    </span>
                    <span>
                        <label htmlFor="date">Select Time</label>
                        <input type="datetime" name="" id="" />
                    </span>
                    <span></span>
                </div>
            </div>

            <div className="container mx-auto mt-10">
                <table className="min-w-full table-auto border-collapse border">
                    <thead>
                        <tr>
                            <th className="border px-4 py-2">Exam Name</th>
                            <th className="border px-4 py-2">Subject</th>
                            <th className="border px-4 py-2">Class</th>
                            <th className="border px-4 py-2">Section</th>
                            <th className="border px-4 py-2">Time</th>
                            <th className="border px-4 py-2">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="border px-4 py-2">ClassName Test</td>
                            <td className="border px-4 py-2">Mathematics</td>
                            <td className="border px-4 py-2">4</td>
                            <td className="border px-4 py-2">A</td>
                            <td className="border px-4 py-2">10.00 am - 11.00 am</td>
                            <td className="border px-4 py-2">20/06/2019</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    );
}

export default ExamShedule;